import { useStores } from "../stores/useStores";
import { getQueries } from "../utils/SchoolBlocksUtilities";
import { IView } from "../stores/InterfaceStore";
import URI from "urijs";
import { withoutLocaleInURI } from "../internationalization/i18nURI";

export const useShowHomepage = () => {
  const { organizationStore, interfaceStore } = useStores();
  const queries = getQueries(interfaceStore.currentFullUrl || "");
  return (interfaceStore.view === IView.DEFAULT &&
    organizationStore.organization.json_data?.settings?.appearance
      ?.showWelcomePage &&
    URI(withoutLocaleInURI(interfaceStore.currentFullUrl || "")).path() ===
      "/" &&
    (!queries.showHomepage || queries.showHomepage === "false")) as boolean;
};
